module.exports = __webpack_public_path__ + "img/lupa.89fdfa7d.svg";